module.exports = __webpack_public_path__ + "static/media/Java-Logo.6505cdab.png";